<template>
  <div class="game-status" :style="setStyle()">
    <div class="text-data" v-if="gameCheckSwitch && checkGameText">
      <p class="text-data-box" v-if="isCorrect === 'correct' && gameData.item.checkGameText.positive">
        {{ gameData.item.checkGameText.positive }}
      </p>
      <p class="text-data-box" v-if="isCorrect === 'incorrect' && gameData.item.checkGameText.negative">
        {{ gameData.item.checkGameText.negative }}
      </p>
    </div>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceIn"
      leave-active-class="animated bounceOut"
    >
      <div
        class="game-status-icon"
        v-show="gameCheckSwitch"
        :class="[{ 'correct-answer': isCorrect === 'correct' }, { 'wrong-answer': isCorrect === 'incorrect' }]"
      ></div>
    </transition>
  </div>
</template>

<script>
import { Howler } from 'howler';
import _ from 'lodash';
export default {
  name: 'tr-game-status',
  props: {
    gameStatus: {
      type: null,
      default: function() {
        return false;
      },
    },
  },
  data: function() {
    return {
      sound: null,
      audioStatus: false,
    };
  },
  mounted: function() {
    // console.log('Panel Statusu');
  },
  methods: {
    setStyle() {
      if (this.checkGameText) {
        return { left: '978px', width: '725px' };
      } else {
        return { left: '1578px', width: '125px' };
      }
    },
    giveMeImagePlease(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    setAudioConfig(audio) {
      if (this.sound != null) {
        this.stopPlay();
      }
      this.sound = new Howl({
        src: this.giveMeImagePlease(audio),
        autoplay: true,
        loop: false,
        volume: 1,
        onend: () => {
          this.audioStatus = false;
          console.log('end');
        },
        onpause: () => {
          this.audioStatus = false;
          console.log('end');
        },
        onstop: () => {
          this.audioStatus = false;
          console.log('end');
        },
        onplay: () => {
          this.audioStatus = true;
          console.log('sztart');
        },
      });
      // this.startPlay();
    },
    startPlay() {
      if (!this.audioStatus) {
        this.sound.play();
      } else {
        this.stopPlay();
      }
    },
    stopPlay() {
      this.sound.stop();
    },
  },
  beforeDestroy() {
    if (this.sound) this.stopPlay();
  },
  computed: {
    checkGameText() {
      if (this.gameData.item.checkGameText) {
        return true;
      } else {
        return false;
      }
      return false;
    },
    isCorrect() {
      return this.gameStatus;
    },
    gameCheckSwitch() {
      // console.log('GAME S: ' + this.$store.getters.gameCheckSwitch);
      if (!this.gameData.item.gameConfig.withoutCheck) {
        if (this.gameData.item.checkGameSound) {
          if (this.$store.getters.gameCheckSwitch) {
            if (this.isCorrect == 'correct') {
              console.log('TRUE!!!!');
              if (this.gameData.item.checkGameSound.positive)
                this.setAudioConfig(this.gameData.item.checkGameSound.positive);
            } else {
              console.log('FALSE!!!!');
              if (this.gameData.item.checkGameSound.negative)
                this.setAudioConfig(this.gameData.item.checkGameSound.negative);
            }
          }
        }
      }
      return this.$store.getters.gameCheckSwitch;
    },
    blockCheckAction() {
      return this.$store.getters.blockCheckAction;
    },
    gameData() {
      return this.$store.getters.gameData;
    },
    // gameStatusText() {
    //   return this.isCorrect ? 'dobrze' : 'źle';
    // },
    // icon() {
    //   return faStar;
    // }
  },
};
</script>

<style lang="scss">
@import '~@/assets/sass/iconColor';
@import '~@/assets/sass/animation';
.game-status {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 954px;
  // left: 1178px;
  // width: 525px;
  height: 125px;
  z-index: 1;
  // font-size: 30px;
  // border: solid 1px black;
  // border-radius: 50%;
  // width: 10%;
  // height: 18%;
  .game-status-icon {
    display: flex;
    padding: 5%;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    width: 100%;
    height: 100%;
    .game-status-text {
      color: green;
      padding-left: 10%;
    }
  }
  .text-data {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 130px;
    max-width: 580px;
    max-height: 125px;
    background: #e6e6e6;
    border-radius: 8px;
    .text-data-box {
      padding: 30px;
      margin: 0;
      font-size: 28px;
      font-family: Calibri;
    }
  }
  .correct-answer {
    background-image: url('~@/assets/icons/gameInterface/statusCorrect.png');
    background-position: right;
    // background-color: $iconStarFirstColor;
  }
  .wrong-answer {
    background-image: url('~@/assets/icons/gameInterface/statusWrong.png');
    background-position: right;
    // background-color: $iconStarFirstColor;
  }
  .unset-answer {
    opacity: 0;
    background-image: url('~@/assets/icons/gameInterface/statusCorrect.png');
    background-position: right;
    // background-color: $iconStarFirstColor;
  }
}
/**
 * hack dla scali i przesuniecia z canvasem w cwiczeniach
 * @type {[type]}
 */

.hack-game-status {
  transform: translate(-50%, -50%) scale(0.7) !important;
  left: 58.5% !important;
  top: 66.8% !important;
}
</style>
